import React from 'react'
import { connect } from 'react-redux'

const Main = (props) => {
  console.log(props)
  return <div>
    <h1>
      SOU O MAIN!!
    </h1>
  </div>
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.user
  }
}

export default connect(mapStateToProps)(Main)



// WEBPACK FOOTER //
// ./src/containers/Main.js